import { ref, onMounted } from 'vue';
import loadScriptPromise from '../../utils/loadScriptPromise';
export default function useWeChatEnv() {
  const isWeChat = ref(false);
  const isMiniProgram = ref(false);

  const checkWeChatEnv = async () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i)) {
      isWeChat.value = true;

      if (window.isWx) {
        await loadScriptPromise(
          'https://g20.gsf.netease.com/2025041502npm/tx_npm/202504117/wx.js'
        );
        if (window.__wxjs_environment === 'miniprogram') {
          isMiniProgram.value = true;
        /* eslint-disable */
        } else if (typeof wx !== 'undefined' && wx.miniProgram) {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              isMiniProgram.value = true;
            }
          });
        }
        /* eslint-enable */
      }
    }
  };

  onMounted(async () => {
    await checkWeChatEnv();
  });

  return {
    isWeChat,
    isMiniProgram,
  };
}
